import React from "react";
import { Icon } from "../comp/Icon";

export class WelcomePage extends React.Component {
    constructor(props) {
        super(props);

        this.dismiss = this.dismiss.bind(this);
        this.load = this.load.bind(this);
    }

    dismiss() {
        this.props.dismiss(false);
    }

    load() {
        this.props.dismiss(true);
    }


    render() {

        // show/hide
        var classes = "overlay welcome-page";

        if(!this.props.open) {
            classes += " hidden";
        }


        return (
            <div className={classes}>
                <div className="overlay-inner">
                    <div className="body">
                        <h1>Emoji Maker</h1>

                        <div className="welcome-option" onClick={this.dismiss}>
                            <span className="icon"><Icon type="fa-file" /></span>

                            <span className="label">New</span>
                        </div>

                        <div className="welcome-option" onClick={this.load}>
                            <span className="icon"><Icon type="fa-th-list" /></span>

                            <span className="label">Load</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


WelcomePage.defaultProps = {
    open: false
};
